import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const services = [
    { slug: 'web-development', titleKey: 'services.webDevelopment' },
    { slug: 'mobile-apps', titleKey: 'services.mobileApps' },
    { slug: 'infrastructure', titleKey: 'services.infrastructure' },
    { slug: 'partnership', titleKey: 'services.partnership' },
];

const ServiceNav = ({ currentSlug, lang }) => {
    const { t } = useTranslation();
    const index = services.findIndex(s => s.slug === currentSlug);
    const prev = services[(index - 1 + services.length) % services.length];
    const next = services[(index + 1) % services.length];

    return (
        <>
            <Link
                to={`/${lang}/services/${prev.slug}`}
                className="pd-nav pd-nav-prev"
            >
                <span className="pd-nav-icon"><i className="fas fa-arrow-left"></i></span>
                <span className="pd-nav-label">
                    <small>PREVIOUS</small>
                    <strong>{t(prev.titleKey)}</strong>
                </span>
            </Link>
            <Link
                to={`/${lang}/services/${next.slug}`}
                className="pd-nav pd-nav-next"
            >
                <span className="pd-nav-label">
                    <small>NEXT</small>
                    <strong>{t(next.titleKey)}</strong>
                </span>
                <span className="pd-nav-icon"><i className="fas fa-arrow-right"></i></span>
            </Link>
        </>
    );
};

export default ServiceNav;
